const header = document.querySelector('.c-header');
if(header){
  const headerNavWrap = header.querySelector('.c-header-nav_wrap'),
        menuBtns = header.querySelectorAll('.c-menu-btn');

  if(headerNavWrap && menuBtns.length > 0){
    const headerNav = headerNavWrap.querySelector('.c-header-nav');

    gsap.set(headerNavWrap, { display: 'flex', autoAlpha: 0 });
    gsap.set(headerNav, { xPercent: 100 });

    // MENU SLIDEOUT TL
    let tlMenu = gsap.timeline({ 
      paused: true, 
      duration: 0.6, 
      ease: 'cubic-bezier(.165, .84, .44, 1)' 
    });
    tlMenu.to(headerNavWrap, {
      autoAlpha: 1,
    }, 0)
    .to(headerNav, {
      xPercent: 0,
      delay: 0.2,
    }, 0);

    

    // MENU OPEN/CLOSE
    let menuOpen = false;
    menuBtns.forEach(menuBtn => {
      menuBtn.addEventListener('click', function(e){
        e.preventDefault();
        header.classList.toggle('menu-open');

        if(menuOpen === false){
          openMenu();
        } else{
          closeMenu();
        }
      });
    });
    
    headerNavWrap.addEventListener('click', function(e){
      if(e.target === headerNavWrap){
        closeMenu();
      }
    });

    function openMenu(){
      tlMenu.play();
      document.body.classList.add('no-scroll');
      menuOpen = true;
    }
    function closeMenu(){
      tlMenu.reverse();
      document.body.classList.remove('no-scroll');
      menuOpen = false;
    }


    // CLOSE ON CLICK OUTSIDE MENU
    document.addEventListener('click', function(e){
      if(menuOpen === true){
        if(!header.contains(e.target)){
          closeMenu();
        }
      }
    });
  }
}